import StoreBadges from './StoreBadges';

export default StoreBadges;
